export default "__VITE_ASSET__bb78d17f__"